import { render } from "./form-eval-score-epc.vue?vue&type=template&id=edb4d22c"
import script from "./form-eval-score-epc.vue?vue&type=script&lang=js"
export * from "./form-eval-score-epc.vue?vue&type=script&lang=js"

import "./form-eval-score-epc.vue?vue&type=style&index=0&id=edb4d22c&lang=scss"

import exportComponent from "F:\\_gitProj\\zj_qd_2022\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__